import React, {useEffect,useState} from 'react';
import {useSelector} from 'react-redux';
import axios from 'axios';
import {sharedservices} from '../../../../url';
import './SharedServices.scss';

const SharedServices = () => {
    const [sharedServices,setSharedServices] = useState<any>([])
    const jwtIdToken = useSelector((state:any) => state.user.token)
    const getSharedServices = async () => {
        const response = await axios.get(sharedservices,{
            headers: {
                'Authorization': jwtIdToken
            }
        });
        if(response.status === 200) {
            let data = response.data
            setSharedServices(data)
        } else {
            console.log('Server Issue')
        }
    }

    useEffect(()=>{
        getSharedServices();
        const interval:ReturnType<typeof setInterval> = setInterval(()=> {
            getSharedServices();
        },30000)

        return () => {
            clearInterval(interval);
        }
    },[]);

    //console.log('sharedservices',sharedServices);
    return <div className='sharedServices mt-4'>
        <p className='blockTitle ms-3'>Shared Services</p>
        <div className='sharedServicescontainer'>
          {
              sharedServices.length?
              sharedServices.map((item:any,index:number) => {
               let imageUrl = item.img_url;
               let service_region = item.region;
               

               if(item.region) {
                   service_region=service_region.toUpperCase();
               }
               else {
                   service_region = "";
               }
               return <div className='serviceBlock' key={index}>
                <div className='clearfix'>
                    {service_region.length? <p className='activeRegion float-start mb-0'>{service_region}</p>: null }
                    <span className='lastUpdated float-lg-end'>{item.timestamp}</span>
                </div>
                <div className='logoBlock'>
                    <a href={item.url} target='_blank' rel="noreferrer" className='navBlock'>
                        <div className='serviceLogoBlock'>
                            {/* <img src={logoImg(imageUrl)} alt={item.img_url} className='logoImg' /> */}
                            <img src={imageUrl} alt={item.name} className='logoImg' />
                        </div>
                    </a>
                    {
                        (item.status).toLowerCase() === 'healthy' ?
                        <div className='smallBadge successBadge'>{item.status}</div> :
                        (item.status).toLowerCase() === 'unhealthy' ?
                        <div className='smallBadge warningBadge'>{item.status}</div> :
                        <div className='smallBadge errorBadge'>{item.status}</div>
                    }
                </div>
                </div>
              }): <div className='ms-3'>No Data Available</div>
          }
        </div>
    </div>
}

export default SharedServices
